import { apiClient, uploadFileClient } from './axios';
import { routes } from './routes';

export const callAdminLogin = (payload) => {
  return apiClient({
    method: routes.ADMIN_LOGIN.METHOD,
    url: routes.ADMIN_LOGIN.URL,
    data: payload,
  });
};
export const addMember = (payload) => {
  return apiClient({
    method: routes.ADD_MEMBER.METHOD,
    url: routes.ADD_MEMBER.URL,
    data: payload,
  });
};
export const updateMember = (payload) => {
  return apiClient({
    method: routes.UPDATE_MEMBER.METHOD,
    url: routes.UPDATE_MEMBER.URL,
    data: payload,
  });
};

export const callAdminPaymentListing = (payload) => {
  return apiClient({
    method: routes.PAYMENT_LISTING.METHOD,
    url: routes.PAYMENT_LISTING.URL,
    data: payload,
  });
};
export const callAdminFailedPaymentListing = (payload) => {
  return apiClient({
    method: routes.FAILED_PAYMENT_LISTING.METHOD,
    url: routes.FAILED_PAYMENT_LISTING.URL,
    data: payload,
  });
};

export const bundleHistory = (payload) => {
  return apiClient({
    method: routes.BUNDLE_HISTORY.METHOD,
    url: routes.BUNDLE_HISTORY.URL,
    data: payload,
  });
};
export const callHistory = (payload) => {
  return apiClient({
    method: routes.CALL_HISTORY.METHOD,
    url: routes.CALL_HISTORY.URL,
    data: payload,
  });
};
export const smsHistory = (payload) => {
  return apiClient({
    method: routes.SMS_HISTORY.METHOD,
    url: routes.SMS_HISTORY.URL,
    data: payload,
  });
};
export const paymentHistory = (payload) => {
  return apiClient({
    method: routes.PAYMENT_HISTORY.METHOD,
    url: routes.PAYMENT_HISTORY.URL,
    data: payload,
  });
};
export const callPlanListing = (payload) => {
  return apiClient({
    method: routes.PLAN_LISTING.METHOD,
    url: routes.PLAN_LISTING.URL,
    data: payload,
  });
};
export const addPlan = (payload) => {
  return apiClient({
    method: routes.ADD_PLAN.METHOD,
    url: routes.ADD_PLAN.URL,
    data: payload,
  });
};
export const callBundleListing = (payload) => {
  return apiClient({
    method: routes.BUNDLE_LISTING.METHOD,
    url: routes.BUNDLE_LISTING.URL,
    data: payload,
  });
};
export const callBundleListingSMS = (payload) => {
  return apiClient({
    method: routes.BUNDLE_LISTING_SMS.METHOD,
    url: routes.BUNDLE_LISTING_SMS.URL,
    data: payload,
  });
};
export const callBundleListingVN = (payload) => {
  return apiClient({
    method: routes.BUNDLE_LISTING_VN.METHOD,
    url: routes.BUNDLE_LISTING_VN.URL,
    data: payload,
  });
};
export const callBundleListingCALL = (payload) => {
  return apiClient({
    method: routes.BUNDLE_LISTING_CALL.METHOD,
    url: routes.BUNDLE_LISTING_CALL.URL,
    data: payload,
  });
};
export const addBundle = (payload) => {
  return apiClient({
    method: routes.ADD_BUNDLE.METHOD,
    url: routes.ADD_BUNDLE.URL,
    data: payload,
  });
};
export const updateBundle = (payload) => {
  return apiClient({
    method: routes.UPDATE_BUNDLE.METHOD,
    url: routes.UPDATE_BUNDLE.URL,
    data: payload,
  });
};
export const deleteNumber = (payload) => {
  return apiClient({
    method: routes.DELETE_NUMBER.METHOD,
    url: routes.DELETE_NUMBER.URL,
    data: payload,
  });
};
export const callNumberListing = (payload) => {
  return apiClient({
    method: routes.NUMBER_LISTING.METHOD,
    url: routes.NUMBER_LISTING.URL,
    data: payload,
  });
};

export const deleteMember = (payload) => {
  return apiClient({
    method: routes.DELETE_MEMBER.METHOD,
    url: routes.DELETE_MEMBER.URL,
    data: payload,
  });
};
export const callAdminUserListing = (payload) => {
  return apiClient({
    method: routes.USER_LISTING.METHOD,
    url: routes.USER_LISTING.URL,
    data: payload,
  });
};

export const callAdminUpdateUser = (payload) => {
  return apiClient({
    method: routes.ADMIN_UPDATE_USER.METHOD,
    url: routes.ADMIN_UPDATE_USER.URL,
    data: payload,
  });
};

export const callAdminPlanListing = () => {
  return apiClient({
    method: routes.PLAN_LISTING.METHOD,
    url: routes.PLAN_LISTING.URL,
  });
};

export const callAdminCreatePlan = (payload) => {
  return apiClient({
    method: routes.ADMIN_CREATE_PLAN.METHOD,
    url: routes.ADMIN_CREATE_PLAN.URL,
    data: payload,
  });
};

export const callAdminMemberListing = (payload) => {
  return apiClient({
    method: routes.MEMBER_LISTING.METHOD,
    url: routes.MEMBER_LISTING.URL,
    data: payload,
  });
};

export const deleteMemberListing = (payload) => {
  return apiClient({
    method: routes.DELETE_MEMBER.METHOD,
    url: routes.DELETE_MEMBER.URL,
    data: payload,
  });
};

export const callAdminRefundAmount = (payload) => {
  return apiClient({
    method: routes.PAYMENT_REFUND.METHOD,
    url: routes.PAYMENT_REFUND.URL,
    data: payload,
  });
};
export const dashboardCalls = (payload) => {
  const data = payload.queryKey[1];
  return apiClient({
    method: routes.Dashboard.Calls.METHOD,
    url: routes.Dashboard.Calls.URL,
    data,
  });
};
export const dashboardPayments = () => {
  return apiClient({
    method: routes.Dashboard.Payments.METHOD,
    url: routes.Dashboard.Payments.URL,
  });
};
export const dashboardUsers = () => {
  return apiClient({
    method: routes.Dashboard.Users.METHOD,
    url: routes.Dashboard.Users.URL,
  });
};

export const callAdminUpdatePlan = (payload) => {
  return apiClient({
    method: routes.ADMIN_UPDATE_PLAN.METHOD,
    url: routes.ADMIN_UPDATE_PLAN.URL,
    data: payload,
  });
};

export const callFeaturesListing = (payload) => {
  return apiClient({
    method: routes.FEATURES_LISTING.METHOD,
    url: routes.FEATURES_LISTING.URL,
    data: payload,
  });
};

export const callUpdateFeaturesListing = (payload) => {
  return apiClient({
    method: routes.UPDATE_FEATURES_LISTING.METHOD,
    url: routes.UPDATE_FEATURES_LISTING.URL,
    data: payload,
  });
};

export const callAddFeaturesListing = (payload) => {
  return apiClient({
    method: routes.ADD_FEATURES_LISTING.METHOD,
    url: routes.ADD_FEATURES_LISTING.URL,
    data: payload,
  });
};
export const callRates = (payload) => {
  return apiClient({
    method: routes.RATES_CALL.METHOD,
    url: routes.RATES_CALL.URL,
    data: payload,
  });
};
export const smsRates = (payload) => {
  return apiClient({
    method: routes.RATES_SMS.METHOD,
    url: routes.RATES_SMS.URL,
    data: payload,
  });
};
export const providers = (payload) => {
  return apiClient({
    method: routes.PROVIDERS.METHOD,
    url: routes.PROVIDERS.URL,
    data: payload,
  });
};

export const callPlanFeaturesListing = () => {
  return apiClient({
    method: routes.PLAN_FEATURES_LISTING.METHOD,
    url: routes.PLAN_FEATURES_LISTING.URL,
  });
};
export const goToDashboard = (payload) => {
  return apiClient({
    method: routes.ADMIN_LOGIN_DASHBOARD.METHOD,
    url: routes.ADMIN_LOGIN_DASHBOARD.URL,
    data: payload,
  });
};
export const paymentRefund = (payload) => {
  return apiClient({
    method: routes.REFUND_HISTORY.METHOD,
    url: routes.REFUND_HISTORY.URL,
    data: payload,
  });
};
export const createProvider = (payload) => {
  return apiClient({
    method: routes.CREATE_PROVIDER.METHOD,
    url: routes.CREATE_PROVIDER.URL,
    data: payload,
  });
};
export const updateProvider = (payload) => {
  return apiClient({
    method: routes.UPDATE_PROVIDER.METHOD,
    url: routes.UPDATE_PROVIDER.URL,
    data: payload,
  });
};
export const deleteProvider = (payload) => {
  return apiClient({
    method: routes.DELETE_PROVIDER.METHOD,
    url: routes.DELETE_PROVIDER.URL,
    data: payload,
  });
};
export const createSettings = (payload) => {
  return apiClient({
    method: routes.CREATE_SETTINGS.METHOD,
    url: routes.CREATE_SETTINGS.URL,
    data: payload,
  });
};
export const updateSettings = (payload) => {
  return apiClient({
    method: routes.UPDATE_SETTINGS.METHOD,
    url: routes.UPDATE_SETTINGS.URL,
    data: payload,
  });
};
export const updateCallMargin = (payload) => {
  return apiClient({
    method: routes.UPDATE_CALL_MARGIN.METHOD,
    url: routes.UPDATE_CALL_MARGIN.URL,
    data: payload,
  });
};
export const updateSMSMargin = (payload) => {
  return apiClient({
    method: routes.UPDATE_SMS_MARGIN.METHOD,
    url: routes.UPDATE_SMS_MARGIN.URL,
    data: payload,
  });
};
export const uploadCallRates = (payload) => {
  return uploadFileClient({
    method: routes.UPLOAD_CALL_RATES.METHOD,
    url: routes.UPLOAD_CALL_RATES.URL,
    data: payload,
  });
};
export const uploadSMSRates = (payload) => {
  return uploadFileClient({
    method: routes.UPLOAD_SMS_RATES.METHOD,
    url: routes.UPLOAD_SMS_RATES.URL,
    data: payload,
  });
};
export const franceList = (payload) => {
  return apiClient({
    method: routes.FRANCE_LIST.METHOD,
    url: routes.FRANCE_LIST.URL,
    data: payload,
  });
};
export const franceListUpdate = (payload) => {
  return apiClient({
    method: routes.FRANCE_LIST_UPDATE.METHOD,
    url: routes.FRANCE_LIST_UPDATE.URL,
    data: payload,
  });
};
export const getBundleDetails = (payload) => {
  return apiClient({
    method: routes.GET_BUNDLE_DETAIL.METHOD,
    url: routes.GET_BUNDLE_DETAIL.URL,
    data: payload,
  });
};
export const franceCreate = (payload) => {
  return apiClient({
    method: routes.FRANCE_CREATE.METHOD,
    url: routes.FRANCE_CREATE.URL,
    data: payload,
  });
};
export const franceUpdate = (payload) => {
  return apiClient({
    method: routes.FRANCE_UPDATE.METHOD,
    url: routes.FRANCE_UPDATE.URL,
    data: payload,
  });
};
export const franceDelete = (payload) => {
  return apiClient({
    method: routes.FRANCE_DELETE.METHOD,
    url: routes.FRANCE_DELETE.URL,
    data: payload,
  });
};
export const didUpdate = (payload) => {
  return apiClient({
    method: routes.DID_UPDATE.METHOD,
    url: routes.DID_UPDATE.URL,
    data: payload,
  });
};
export const customerBundleUpdate = (payload) => {
  return apiClient({
    method: routes.CUSTOMER_BUNDLE_UPDATE.METHOD,
    url: routes.CUSTOMER_BUNDLE_UPDATE.URL,
    data: payload,
  });
};
export const franceDeleteRequest = (payload) => {
  return apiClient({
    method: routes.FRANCE_DID_REQUEST_DELETE.METHOD,
    url: routes.FRANCE_DID_REQUEST_DELETE.URL,
    data: payload,
  });
};
export const deleteBundleComplete = (payload) => {
  return apiClient({
    method: routes.BUNDLE_COMPLETE_DELETE.METHOD,
    url: `/bundle/${payload}`,
  });
};
export const getAllDIDCountries = (payload) => {
  return apiClient({
    method: routes.GET_ALL_DID_COUNTRIES.METHOD,
    url: routes.GET_ALL_DID_COUNTRIES.URL,
    data: payload,
  });
};
export const deleteDidCountry = (payload) => {
  return apiClient({
    method: routes.DELETE_DID_CONTRY.METHOD,
    url: routes.DELETE_DID_CONTRY.URL,
    data: payload,
  });
};
export const getAllDIDCountriesList = (payload) => {
  return apiClient({
    method: routes.GET_ALL_DID_COUNTRIES_LIST.METHOD,
    url: routes.GET_ALL_DID_COUNTRIES_LIST.URL,
    data: payload,
  });
};
export const addDIDCountryToList = (payload) => {
  return apiClient({
    method: routes.ADD_COUNTRY_DID.METHOD,
    url: routes.ADD_COUNTRY_DID.URL,
    data: payload,
  });
};
export const changeStatusCountry = (payload) => {
  return apiClient({
    method: routes.CHANGE_STATUS_COUNTRY.METHOD,
    url: routes.CHANGE_STATUS_COUNTRY.URL,
    data: payload,
  });
};
export const franceDIDAssign = (payload) => {
  return apiClient({
    method: routes.FRANCE_DID_ASSIGN.METHOD,
    url: routes.FRANCE_DID_ASSIGN.URL,
    data: payload,
  });
};
export const getSettings = () => {
  return apiClient({
    method: routes.GET_SETTINGS.METHOD,
    url: routes.GET_SETTINGS.URL,
  });
};
export const getFranceRequestedList = (payload) => {
  return apiClient({
    method: routes.FRANCE_DID_REQUEST.METHOD,
    url: routes.FRANCE_DID_REQUEST.URL,
    data: payload,
  });
};
export const getAllProviderCall = () => {
  return apiClient({
    method: routes.ALL_PROVIDER_CALL.METHOD,
    url: routes.ALL_PROVIDER_CALL.URL,
  });
};
export const getAllProviderSMS = () => {
  return apiClient({
    method: routes.ALL_PROVIDER_SMS.METHOD,
    url: routes.ALL_PROVIDER_SMS.URL,
  });
};
export const getFranceCity = () => {
  return apiClient({
    method: routes.FRANCE_CITIES.METHOD,
    url: routes.FRANCE_CITIES.URL,
  });
};
export const fileExport = (payload, url) => {
  return apiClient({
    method: 'POST',
    url: `/${url}/export`,
    data: payload,
  });
};
export const callAdminLiveUserListing = (payload) => {
  return apiClient({
    method: routes.LIVE_USERS_LISTING.METHOD,
    url: routes.LIVE_USERS_LISTING.URL,
    data: payload,
  });
};
export const callAdminLiveVnNumberListing = (payload) => {
  return apiClient({
    method: routes.LIVE_VN_NUMBER_LISTING.METHOD,
    url: routes.LIVE_VN_NUMBER_LISTING.URL,
    data: payload,
  });
};
export const externalPaymentList = (payload) => {
  return apiClient({
    method: routes.EXTERNAL_PAYMENT_LIST.METHOD,
    url: routes.EXTERNAL_PAYMENT_LIST.URL,
    data: payload,
  });
};
export const uploadLiveUsers = (payload) => {
  return uploadFileClient({
    method: routes.UPLOAD_LIVE_USERS.METHOD,
    url: routes.UPLOAD_LIVE_USERS.URL,
    data: payload,
  });
};
export const uploadLiveNumber = (payload) => {
  return uploadFileClient({
    method: routes.UPLOAD_LIVE_NUMBER.METHOD,
    url: routes.UPLOAD_LIVE_NUMBER.URL,
    data: payload,
  });
};
export const editKYCDetails = (payload) => {
  return apiClient({
    method: routes.EDIT_KYC_DETAILS.METHOD,
    url: routes.EDIT_KYC_DETAILS.URL,
    data: payload,
  });
};
export const KYCVerification = (id) => {
  return uploadFileClient({
    method: routes.KYC_VERIFICATION.METHOD,
    url: `${routes.KYC_VERIFICATION.URL}/${id}`,
  });
};
export const profType = ({ type }) => {
  return uploadFileClient({
    method: routes.PROF_TYPE.METHOD,
    url: `${routes.PROF_TYPE.URL}/${type}`,
  });
};
export const addressProofType = () => {
  return uploadFileClient({
    method: routes.ADDRESS_PRO0F_TYPE.METHOD,
    url: routes.ADDRESS_PRO0F_TYPE.URL,
  });
};
export const proofTypeID = ({ type }) => {
  return uploadFileClient({
    method: routes.PROOF_TYPE_ID.METHOD,
    url: `${routes.PROOF_TYPE_ID.URL}/${type}`,
  });
};
export const fetchMediaURL = (payload) => {
  return uploadFileClient({
    baseURL: 'https://zeyi-dev-api.mobilisedev.co.uk',
    method: routes.MEDIA_UPLOAD.METHOD,
    url: routes.MEDIA_UPLOAD.URL,
    data: payload,
  });
};



export const expiredVNList = (payload) => {
  return apiClient({
    method: routes.EXPIRED_VN_LIST.METHOD,
    url: routes.EXPIRED_VN_LIST.URL,
    data: payload,
  });
};
export const expiredVNRevert = (payload) => {
  return apiClient({
    method: routes.EXPIRED_VN_REVERT.METHOD,
    url: routes.EXPIRED_VN_REVERT.URL,
    data: payload,
  });
};
export const expiredVNDelete = (payload) => {
  return apiClient({
    method: routes.EXPIRED_VN_DELETE.METHOD,
    url: routes.EXPIRED_VN_DELETE.URL,
    data: payload,
  });
};

export const didPortedListing = (payload) => {
  return apiClient({
    method: routes.DID_PORTED_LISTING.METHOD,
    url: routes.DID_PORTED_LISTING.URL,
    data: payload,
  });
};
export const createDidPorted = (payload) => {
  return apiClient({
    method: routes.ADD_PORTED.METHOD,
    url: routes.ADD_PORTED.URL,
    data: payload,
  });
};
export const updateDidPorted = (payload) => {
  return apiClient({
    method: routes.UPDATE_PORTED.METHOD,
    url: routes.UPDATE_PORTED.URL,
    data: payload,
  });
};
export const deleteDidPorted = (payload) => {
  return apiClient({
    method: routes.DELETE_PORTED.METHOD,
    url: routes.DELETE_PORTED.URL,
    data: payload,
  });
};
export const verifyMISDN = (payload) => {
  return apiClient({
    method: routes.VERIFY_MSIDN.METHOD,
    url: routes.VERIFY_MSIDN.URL,
    data: payload,
  });
};
export const routePrefix = (payload) => {
  return apiClient({
    method: routes.ROUTE_PREFIX.METHOD,
    url: routes.ROUTE_PREFIX.URL,
    data: payload,
  });
};
